/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  SystemActionsSortInput,
  useGetSystemActionsQuery,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: SystemActionsSortInput;
};

export function useGetSystemActions({ page, limit, sort }: Props) {
  const { data, loading, error } = useGetSystemActionsQuery({
    variables: { page: Number(page), limit: Number(limit), sort },
  });
  const count = data?.systemActions.pageInfo?.count ?? 0;

  return {
    data: data?.systemActions?.result ?? [],
    loading,
    error,
    count,
  } as const;
}
